import { Component, OnInit, EventEmitter, ViewChild, ElementRef, Input, Output } from '@angular/core';
import { MessageType } from './message-type';
import { MessageStatus } from './message-status';
import { ModalDirective } from 'ngx-bootstrap/modal';


export class ModalMessageComponent implements OnInit {
  
  message: string;

  
  status: string;

  
  type: string;

   onOk: EventEmitter<boolean> = new EventEmitter();
   onClose: EventEmitter<any> = new EventEmitter();

   modal: ModalDirective;

  constructor() {
  }

  ngOnInit() { }

  /**
   * Mehtod that returns the modal icon to display depending of the modal status
   */
  getIcon() {
    switch (this.status) {
      case MessageStatus.DANGER:
        return 'fa-times';
      case MessageStatus.INFO:
        return 'fa-info-circle';
      case MessageStatus.SUCCESS:
        return 'fa-check ';
      case MessageStatus.WARNING:
        return 'fa-exclamation-triangle';
      default:
        return 'fa-times';
    }
  }

  /**
   * Mehtod that returns the modal title depending of the model status
   */
  getTitle() {
    switch (this.status) {
      case MessageStatus.DANGER:
        return 'Error';
      case MessageStatus.INFO:
        return 'Info';
      case MessageStatus.SUCCESS:
        return 'Success ';
      case MessageStatus.WARNING:
        return 'Warning';
      default:
        return 'Error';
    }
  }

  /**
   * Mehtod that returns the Ok title button translated
   */
  getOkTitle() {
    // TO be translated
    return 'OK';
  }

  /**
   * Method that returns the cancel title button translated
   */
  getCancelTitle() {
    // TO be translated
    if (this.type === MessageType.BLOCKING) {
      return 'Close';
    } else {
      return 'Cancel';
    }
  }

  /**
   * Event that show the modal dialog
   */
  show() {
    this.modal.show();
  }

  /**
   * Event that hide the modal dialog
   */
  hide() {
    if (this.modal && this.modal.isShown) {
      if (this.type === MessageType.CONFIRM) {
        this.onOk.emit(false);
      }
      this.modal.hide();
      this.onClose.emit(null);
    }
  }

  /**
   * Event fired when click on ok button of confirm message
   */
  onOKEvent() {
    this.onOk.emit(true);
    this.modal.hide();
    this.onClose.emit(null);
  }

  /**
   * Event fired when click on cancel or close button
   */
  onCancelEvent() {
    this.hide();
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'app-modal-message',
  template: `
  <div class="modal fade" bsModal #modalMsg="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title pull-left"><i class="fa {{getIcon()}}" aria-hidden="true"></i> {{getTitle()}}</h4>
          <button type="button" class="close pull-right" aria-label="Close" (click)="modalMsg.hide()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">{{message}}</div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" (click)="onOKEvent()" *ngIf="type == 'CONFIRM'">{{getOkTitle()}}</button>
          <button type="button" class="btn btn-primary" (click)="onCancelEvent()">{{getCancelTitle()}}</button>
        </div>
      </div>
    </div>
  </div>
  `,
  styles: [`

  .fa-times {
      color: red;
  }
  .fa-info-circle {
      color: blue;
  }
  .fa-exclamation-triangle {
      color: orange;
  }

  .fa-exclamation-triangle {
      color: orange;
  }

  .fa-check {
      color: green;
  }
  `]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'message': [{ type: Input },],
'status': [{ type: Input },],
'type': [{ type: Input },],
'onOk': [{ type: Output },],
'onClose': [{ type: Output },],
'modal': [{ type: ViewChild, args: ['modalMsg', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
